export default function MySQL_VIEWS() {
  return (
    <div>
      <h2>MySQL_VIEWS</h2>    </div>
  );
}